import { render, staticRenderFns } from "./FichaExtendidaDocumentales.vue?vue&type=template&id=5f7f2a92&"
import script from "./FichaExtendidaDocumentales.vue?vue&type=script&lang=js&"
export * from "./FichaExtendidaDocumentales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FichaExtendidaDocumentales.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports